import React from 'react';
import _ from 'lodash';

import Button from '../../../../../core/web/js/button/Button';
import AddButton from '../../../../../core/web/js/button/Add';
import ResetButton from '../../../../../core/web/js/button/Reset';
import TextInput from '../../../../../core/web/js/form/TextInput';
import {change} from '../../../../../core/web/js/form/FormUtil';
import ErrorMessage from '../../../../../core/web/js/message/Error';
import {closeMessage} from '../../../../../core/web/js/message/MessageUtil';

import backgrounds from '../../../json/backgrounds.json';

import '../../../css/createCharacter.css';

import Background from './Background';
import BackgroundSelect from './BackgroundSelect';


/**
 *
 */
function CreateCharacter(props){
  return (
    <div className="createCharacter">
      <ErrorMessage message={props.state.errorMessage}
        close={closeMessage.bind(this,props,'errorMessage')}
        duration={5000}
      />
      {_renderContent(props)}
      {_renderActionPane(props)}
    </div>
  );
}


/**
 *
 */
function _renderContent(props){
  return (
    <div className="content">
      <div className="level">Level {props.state.level}</div>
      <div className="form">
        {_renderName(props)}
        <BackgroundSelect
          state={props.state}
          stateName={props.stateName}
          updateState={props.updateState}
          stats={props.stats}
        />
      </div>
      <br />
      <Background state={props.state} stateName={props.stateName} updateState={props.updateState} />
      <b>Gear Slots</b> {props.state.gearSlots}
    </div>
  );
}


/**
 *
 */
function _renderName(props){
  return (
      <TextInput
        label={"Name"}
        value={props.state.name}
        change={change.bind(this, props, 'name')}
      />
  );
}


/**
 *
 */
function _renderActionPane(props){
  if(props.state.addRoster){
    return (
      <div className="actionPane">
        <AddButton type="primary" onClick={_addToCrew.bind(this, props)}>Add To Crew</AddButton>
        <ResetButton onClick={_resetClick.bind(this, props)} />
        <Button onClick={_cancelClick.bind(this, props)}>Cancel</Button>
      </div>
    )
  }else{
    return null;
  }
}


/**
 *
 */
function _addToCrew(props){
  if(_validate(props)){
    if(props.state.addRoster){
      const data = _getData(props);
      props.state.addRoster(data);
    }else{
      throw Error("Missing add captain callback")
    }
  }
}


/**
 *
 */
function _getData(props){
  const state = _.cloneDeep(props.state);
  const selectedBackground = backgrounds.filter(data=>{
    return data.type===props.state.background;
  })[0];

  let data = {}
  data.name = state.name;
  data.background = state.background;
  data.level = state.level;
  data.move = state.move;
  data.fight = state.fight;
  data.shoot = state.shoot;
  data.armor = state.armor;
  data.will = state.will;
  data.health = state.health;
  data.gearSlots = state.gearSlots;
  data.powers = _.cloneDeep(selectedBackground.corePowers)
  return data;
}

/**
 *
 */
function _validate(props){
  let message="";
  const statPickCount = Object.keys(props.state.statChoices).length;
  const selectedBackground = backgrounds.filter(data=>{
    return data.type===props.state.background;
  })[0];

  if(!props.state.name){
    message = "Name cannot be empty";
  }else if(selectedBackground.statPoints - statPickCount !== 0){
    message = "Please choose stats";
  }

  if(message){
    props.updateState(props.stateName, {'errorMessage':message});
    return false;
  }else{
    return true;
  }
}


/**
 *
 */
function _cancelClick(props){
  props.updateState(props.stateName, {'addRoster':null})
  window.location = '#crew';
}


/**
 *
 */
function _resetClick(props){
  props.resetState(props.stateName, {"addRoster": props.state.addRoster});
}

export default CreateCharacter;
